// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

// ** UseJWT import to get config
import useJwt from "@src/auth/jwt/useJwt";
import { authChannel } from "../configs/broadcastChannels/authBroadcastChannel";
import { AUTH_BROAD_CAST_CHANNEL } from "../configs/broadcastChannels/BROAD_CAST_CONSTANT";

const config = useJwt.jwtConfig;

const initialUser = () => {
  const item = window.localStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    userData: initialUser(),
  },
  reducers: {
    handleLogin: (state, action) => {
      authChannel.postMessage({ type: AUTH_BROAD_CAST_CHANNEL.logIn });
      state.userData = action.payload;
      //
      state[config.storageTokenKeyName] =
        action.payload[config.storageTokenKeyName];
      //
      state[config.storageRefreshTokenKeyName] =
        action.payload[config.storageRefreshTokenKeyName];
      //
      localStorage.setItem("userData", JSON.stringify(action.payload));

      //for style Profile VideoGraphy
      //TODO: will implement condition to set styleProfileVideo Id in localStorage if style_profile_id exist
      localStorage.setItem(
        "styleProfileVideo",
        JSON.stringify(action.payload?.style_profile_id)
      );

      //for style Profile PhotoGraphy
      if (action.payload?.style_profile_photo_id) {
        localStorage.setItem(
          "styleProfilePhoto",
          JSON.stringify(action.payload?.style_profile_photo_id)
        );
      }

      //
      localStorage.setItem(
        config.storageTokenKeyName,
        action.payload.accessToken
      );
      //
      localStorage.setItem(
        config.storageRefreshTokenKeyName,
        action.payload.refreshToken
      );
    },
    handleLogout: (state) => {
      authChannel.postMessage({ type: AUTH_BROAD_CAST_CHANNEL.logOut });
      state.userData = {};
      state[config.storageTokenKeyName] = null;
      state[config.storageRefreshTokenKeyName] = null;
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem("userData");
      localStorage.removeItem("styleProfilePhoto");
      localStorage.removeItem("styleProfileVideo");
      localStorage.removeItem("getDiscountCount");
      localStorage.removeItem("getRetryPaymentCount");
      localStorage.removeItem(config.storageTokenKeyName);
      localStorage.removeItem(config.storageRefreshTokenKeyName);
      localStorage.removeItem("redirectToCreateProject");

      localStorage.setItem("isHardRefresh", true);
      localStorage.removeItem("isOfflineBanner");
      localStorage.removeItem("isWhatsNewOpen");
    },
  },
});

export const { handleLogin, handleLogout } = authSlice.actions;

export default authSlice.reducer;
